<template>
  <v-container>
    <v-row justify="start" align="center">
      <v-col
        role="button"
        tabindex="0"
        title="返回統計頁面"
        class="d-flex align-center"
        @click="changeSide('sideStatic')"
        @keypress="changeSide('sideStatic')"
      >
        <v-icon size="2.25rem">mdi-chevron-left</v-icon>
        <span class="mx-3 ct-text-subtitle3 ct-text-bolder">
          <!-- {{ sideTreeContent.t }} -->
          {{ sideTreeContent.s + "-" + paddingLeft(sid, 6) }}
        </span>
      </v-col>
    </v-row>
    <v-row justify="start" align="center" class="my-3">
      <v-col>
        <div class="d-flex ">
          <span class="ct-text-bolder d-flex align-center">
            <v-img
              :src="
                require(`@/assets/images/map/sideTree/CO2Type${CO2Type}.png`)
              "
              title="CO2Type icon"
              contain
              class="ml-8"
              width="120"
            />
          </span>
          <span
            class="ml-1 my-2 ct-text-subtitle2 ct-text-bolder d-flex align-center"
          >
            {{ SYS.setValueText(sideTreeContent.n, $store.state.map.treeType) }}
            <v-icon :color="sideTreeContent.color"
              >mdi-checkbox-blank-circle</v-icon
            >
          </span>
        </div>
      </v-col>
    </v-row>
    <v-row justify="center" align="center" class="mx-8 content">
      <v-col class="d-flex justify-center align-center">
        <div class="leftSide">
          <v-card height="400">
            <div
              class="d-flex justify-center align-center leftImg"
              style="width: 100%;"
            >
              <img :src="SYS.setImg(photoList[mainImgIdx])" class="mainPhoto" />
            </div>
          </v-card>
        </div>
        <div v-if="photoList.length > 1" class="pa-0 rightSide" cols="4">
          <!-- style="height:400px;overflow:hidden;position:relative" -->
          <div class="rotate90  d-flex justify-start align-center">
            <div class="rotateContent">
              <v-slide-group center-active :show-arrows="false">
                <v-slide-item
                  v-for="(n, idx) in photoList"
                  :key="idx"
                  v-slot="{ active, toggle }"
                >
                  <v-card
                    :color="active ? 'primary' : 'grey lighten-1'"
                    class="mx-2 rightCard"
                    @click="toggle"
                  >
                    <div
                      class="d-flex justify-center align-center"
                      style="width: 100%;"
                    >
                      <img
                        :src="SYS.setImg(n)"
                        class="subPhoto"
                        @click="setMainImg(idx)"
                      />
                    </div>
                  </v-card>
                </v-slide-item>
              </v-slide-group>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col>
        <div
          class="ma-auto d-flex justify-center align-center"
          style="width:150px"
        >
          <div
            v-if="sideTreeContent.b"
            class="treeBtn my-3 mx-3"
            role="button"
            tabindex="0"
            :title="
              `前往${SYS.setValueText(
                sideTreeContent.n,
                $store.state.map.treeType
              )}樹木小百科(另開新視窗)`
            "
            @click="goToBookDetails(sideTreeContent.n)"
            @keypress="goToBookDetails(sideTreeContent.n)"
          >
            <div class="text" style="text-align:center">
              樹木小百科
            </div>
            <div class="ma-auto bg">
              <div class="ma-auto book"></div>
            </div>
          </div>
          <div
            v-if="sideTreeContent.b"
            class="treeBtn my-3 mx-3"
            role="button"
            tabindex="0"
            :title="
              `產生${SYS.setValueText(
                sideTreeContent.n,
                $store.state.map.treeType
              )}解說牌`
            "
            @click="openInfoCard()"
            @keypress="openInfoCard()"
          >
            <div class="text" style="text-align:center">
              產生解說牌
            </div>
            <div class="ma-auto bg">
              <div class="ma-auto qr"></div>
            </div>
          </div>
          <div
            class="treeBtn my-3 mx-3"
            role="button"
            tabindex="0"
            title="前往木林森挑戰(另開新視窗)"
            @click="goToGameWeb()"
            @keypress="goToGameWeb()"
          >
            <div class="text" style="text-align:center">
              木林森挑戰
            </div>
            <div class="ma-auto bg">
              <div class="ma-auto plant-hero"></div>
            </div>
          </div>
        </div>
        <!-- plant-hero -->
      </v-col>
    </v-row>
    <v-row justify="start" align="center" class="my-3">
      <v-col>
        <span class="ml-8 ct-text-subtitle2 ct-text-bolder d-flex align-center"
          >位置</span
        >
      </v-col>
    </v-row>
    <v-row justify="center" align="center" class="mx-8 content mb-5">
      <v-col class="d-flex align-center">
        <v-avatar color="secondary" size="30">
          <span class="white--text ct-text-subtitle3">X</span>
        </v-avatar>
        <span class="mx-3">{{ sideTreeContent.x }}</span>
      </v-col>
      <v-col class="d-flex align-center">
        <v-avatar color="secondary" size="30">
          <span class="white--text ct-text-subtitle3">Y</span>
        </v-avatar>
        <span class="mx-3">{{ sideTreeContent.y }}</span>
      </v-col>
    </v-row>
    <!-- 20250625 carbon hidden -->
    <!-- <v-row justify="start" align="center" class="my-3">
      <v-col>
        <span class="ml-8 ct-text-subtitle2 ct-text-bolder d-flex align-center"
          >測量</span
        >
      </v-col>
    </v-row>
    <v-row justify="center" align="center" class="mx-8 content mb-5">
      <v-col class="d-flex align-center">
        <v-chip color="secondary" size="30">
          <span class="white--text ct-text-subtitle3">樹高</span>
        </v-chip>
        <span class="mx-3" style="white-space: nowrap;">
          {{ H ? `${TOOL.toNumber(H)} 公尺` : "未測量" }}
        </span>
      </v-col>
      <v-col class="d-flex align-center">
        <v-chip color="secondary" size="30">
          <span class="white--text ct-text-subtitle3">胸徑</span>
        </v-chip>
        <span class="mx-3" style="white-space: nowrap;">
          {{ DBH ? `${TOOL.toNumber(DBH)} 公分` : "未測量" }}
        </span>
      </v-col>
    </v-row>
    <v-row v-if="CO2Time" justify="center" align="center" class="mx-8 mb-5">
      <v-col class="d-flex align-center">
        <span>
          {{ `更新時間：${TOOL.setDateString(CO2Time)}` }}
        </span>
      </v-col>
    </v-row> -->
    <!-- 20250625 carbon hidden -->
    <!-- <v-row justify="start" align="center" class="my-3">
      <v-col>
        <span class="ml-8 ct-text-subtitle2 ct-text-bolder d-flex align-center"
          >碳匯估算</span
        >
      </v-col>
    </v-row>
    <v-row justify="center" align="center" class="mx-8 content mb-5">
      <v-col class="d-flex align-center">
        <span class="mx-3" style="min-height:30px;">
          {{
            kgCO2e
              ? `${TOOL.toNumber(kgCO2e).toFixed(2)} 公斤二氧化碳當量`
              : "無"
          }}
        </span>
      </v-col>
    </v-row> -->
    <v-row justify="start" align="center" class="my-3">
      <v-col>
        <span class="ml-8 ct-text-subtitle2 ct-text-bolder d-flex align-center"
          >備註</span
        >
      </v-col>
    </v-row>
    <v-row justify="center" align="center" class="mx-8 content mb-5">
      <v-col class="d-flex align-center">
        <span class="mx-3" style="min-height:30px;">{{
          sideTreeContent.note
        }}</span>
      </v-col>
    </v-row>
    <!-- <v-row justify="start" align="center" class="my-3">
      <v-col>
        <span class="ml-8 ct-text-subtitle2 ct-text-bolder d-flex align-center"
          >樹木簡介</span
        >
      </v-col>
    </v-row>
    <v-row justify="center" align="center" class="mx-8 content">
      <v-col>
        <v-card color="rgba(0,0,0,0)" flat>
          <v-card-text>
            以榕樹基本知識為例： 植物名稱：榕樹 植物學科：桑科 榕屬
            植物特徵：常綠大喬木，高可達 20 公尺以上，樹皮光滑，
            全株具白色乳汁；常有懸垂氣生根等。
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="start" align="center" class="my-3">
      <v-col>
        <span class="ml-8 ct-text-subtitle2 ct-text-bolder d-flex align-center"
          >校樹故事</span
        >
      </v-col>
    </v-row>
    <v-row justify="center" align="center" class="mx-8 content">
      <v-col>
        <v-card color="rgba(0,0,0,0)" flat>
          <v-card-text>
            高雄市成功特教學校
            老榕樹植於民國1940年代，為原台鋁舊員工宿舍區，為昔日居民聚會場所，
            1990年代，因房舍老舊陸續進行拆遷，只剩孤立的老榕樹，命運岌岌可危。
            1995年成功特教學校輾轉來到此地建校與老榕樹相遇。
          </v-card-text>
        </v-card>
      </v-col>
    </v-row> -->
    <v-dialog v-model="infoCardDialog" max-width="545">
      <div style="min-height:485px;position:relative;" class="light white">
        <div style="padding:20px;overflow:auto">
          <InfoCard
            :item="bookItem"
            :sid="sid"
            :city="city"
            :school="school"
            :key="Date.now() + '_ifc'"
          />
          <!-- <div style="min-height:200px;width:100%;background-color:red;"></div> -->
        </div>
        <div style="position:absolute;bottom:0;left:0;right:0">
          <hr />
          <div class="d-flex justify-center align-center my-6">
            <v-btn
              :color="'#FFF777'"
              class="ct-text-bolder mr-8"
              @click="printInfoCard('cardID')"
              >下載圖片</v-btn
            >
            <v-btn
              :color="'#FFF777'"
              class="ct-text-bolder"
              @click="infoCardDialog = false"
              >關閉視窗</v-btn
            >
          </div>
        </div>
      </div>
    </v-dialog>
  </v-container>
</template>

<script>
import html2canvas from "html2canvas/dist/html2canvas";
export default {
  components: {
    InfoCard: () => import("@/components/map/infoCard.vue")
  },
  props: {
    sideTreeContent: {
      type: Object,
      default() {
        return {
          no: ""
        };
      }
    }
  },
  data() {
    return {
      length: 3,
      window: 0,
      photoList: [],
      mainImgIdx: 0,
      bookItem: null,
      infoCardDialog: false,
      sid: null,
      city: null,
      school: null,
      DBH: null,
      H: null,
      kgCO2e: null,
      CO2Time: null,
      CO2Type: null
    };
  },
  watch: {
    sideTreeContent: {
      handler() {
        this.getTreeDetail();
      },
      deep: true,
      immediate: true
    }
  },
  // mounted() {
  //   this.getTreeDetail();
  // },
  methods: {
    async printInfoCard(canvasInstance, triggerDownload = true) {
      const canvas = await html2canvas(
        typeof canvasInstance === "string"
          ? document.getElementById(canvasInstance)
          : canvasInstance,
        {
          allowTaint: true,
          useCORS: true,
          scale: 3,
          backgroundColor: "whte",
          imageTimeout: 600000
        }
      );

      if (triggerDownload) {
        const a = document.createElement("a");
        a.href = canvas
          .toDataURL("image/jpeg")
          .replace("image/jpeg", "image/octet-stream");
        a.download = `${this.SYS.setValueText(
          this.sideTreeContent.n,
          this.$store.state.map.treeType
        )}.jpg`;
        a.click();
      }

      return canvas;
    },
    setMainImg(idx) {
      this.mainImgIdx = idx;
    },
    changeSide(val) {
      this.$emit("changeSide", val);
    },
    getTreeDetail() {
      return this.axios({
        methods: "get",
        url: `${process.env.VUE_APP_API_URL}api/Map/GetTreeDetail`,
        params: {
          id: this.sideTreeContent.no
        }
      }).then(resp => {
        this.photoList = resp.data.data.PhotoList;
        this.bookItem = resp.data.data.bookItem;
        this.sid = resp.data.data.Sid;
        this.city = resp.data.data.Countyid;
        this.school = resp.data.data.Expr1;
        this.DBH = resp.data.data.DBH;
        this.H = resp.data.data.H;
        this.kgCO2e = resp.data.data.kgCO2e;
        this.CO2Time = resp.data.data.CO2Time;
        this.CO2Type = resp.data.data.CO2Type ?? 1;
      });
    },
    openInfoCard() {
      this.infoCardDialog = true;
    },
    goToBookDetails(id) {
      let routeData = this.$router.resolve({
        name: "Book-Detail",
        query: {
          name: id
        }
      });
      window.open(routeData.href, "_blank");
    },
    goToGameWeb() {
      window.open(
        "https://adl.edu.tw/trees/web/static/guess_the_trees_frontend/index.html",
        "_blank"
      );
    },
    paddingLeft(str = "", lenght = 6) {
      if (typeof str == "string" && str.length >= lenght) return str;
      else return this.paddingLeft("0" + str, lenght);
    }
  }
};
</script>

<style lang="scss" scoped>
span {
  display: inline-block;
  &.ct-text-subtitle2 {
    padding-left: 10px;
    padding-right: 10px;
    border-color: #62922a;
    border-width: 5px;
    border-style: none none none solid;
  }
}
.content {
  border-radius: 10px;
  background-color: #f5f5f5;
}
.rightSide {
  overflow: hidden;
  position: relative;
  width: 200px;
  @include phoneAndpad {
    width: 200px;
  }
}
.leftSide {
  width: calc(100% - 216px);
  margin-right: 16px;
  @include phoneAndpad {
    margin-right: 0px;
    width: 100%;
  }
}
.rotate90 {
  // --width: 100%;
  height: 400px;
  width: 200px;
  position: inherit;
  top: -110px;
  // overflow: hidden;
  // scroll-snap-align: center;
  //margin-left: 16px;
  transform: rotate(90deg);
  .rotateContent {
    max-width: none;
    width: 430px;
  }
}
.leftImg {
  min-width: 300px;
  @include phoneAndpad {
    min-width: 100px;
  }
}
.rightCard {
  width: 200px !important;
  height: 200px !important;
  max-height: 200px !important;
  @include phoneAndpad {
    width: 150px !important;
    height: 150px !important;
    max-height: 150px !important;
  }
}
.mainPhoto {
  object-fit: contain;
  height: 400px;
  width: 100%;
  border-radius: 5px;
}
.subPhoto {
  object-fit: cover;
  height: 200px;
  width: 100%;
  @include phoneAndpad {
    height: 150px;
  }
  border-radius: 5px;
  transform: rotate(-90deg);
}

// .treeBtn {
//   .text {
//     white-space: nowrap;
//     font-size: 1rem;
//   }
//   .bg {
//     position: relative;
//     height: 62px;
//     width: 62px;
//     background-size: 100%;
//     background-repeat: no-repeat;
//     background-position: 50% 50%;
//     background-image: url("~@/assets/images/map/sideTree/map_btn_bg.svg");
//     filter: drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.3));
//     .book {
//       position: absolute;
//       top: calc((62px - 24px) / 2);
//       left: calc((62px - 24px) / 2);
//       height: 24px;
//       width: 24px;
//       background-size: 100%;
//       background-repeat: no-repeat;
//       background-position: 50% 50%;
//       background-image: url("~@/assets/images/map/sideTree/map_btn_book.svg");
//     }
//     .qr {
//       position: absolute;
//       top: calc((62px - 24px) / 2);
//       left: calc((62px - 24px) / 2);
//       height: 24px;
//       width: 24px;
//       background-size: 100%;
//       background-repeat: no-repeat;
//       background-position: 50% 50%;
//       background-image: url("~@/assets/images/map/sideTree/map_btn_qr.svg");
//     }
//     .plant-hero {
//       position: absolute;
//       top: calc((62px - 24px) / 2);
//       left: calc((62px - 24px) / 2);
//       height: 24px;
//       width: 24px;
//       background-size: 100%;
//       background-repeat: no-repeat;
//       background-position: 50% 50%;
//       background-image: url("~@/assets/images/map/sideTree/map_btn_plant_hero.svg");
//     }
//   }
// }
</style>
